type Trail = [number, number][];

const verifySolution = (captcha: number, solution: number, tolerance: number) =>
  Math.abs(captcha - solution) < tolerance;

// Slider position must not jump to the solution without intermediate values
const verifyHorizontalMotion = (positions: number[]) =>
  !positions.reduce(
    (jumpToInput, pos) =>
      jumpToInput && (pos === 0 || pos === positions[positions.length - 1]),
    true,
  );

// Vertical motion must be present while dragging the slider
const verifyVerticalMotion = (positions: number[]) =>
  positions.reduce((total, pos) => total + pos) !== 0;

const verifyTrailLength = (trail: Trail) => trail.length;

const verifyResponse = (
  captcha: number,
  solution: number,
  trail: Trail,
  tolerance: number,
) =>
  verifySolution(captcha, solution, tolerance) &&
  verifyTrailLength(trail) &&
  verifyHorizontalMotion(trail.map((t) => t[0])) &&
  verifyVerticalMotion(trail.map((t) => t[1]));

const verifyCaptcha = (
  captcha: number,
  { response, trail }: { response: number; trail: Trail },
  { tolerance = 7, verify = verifyResponse } = {},
) =>
  new Promise((resolve, reject) => {
    if (verify(captcha, response, trail, tolerance)) {
      resolve({
        result: 'success',
      });
    } else {
      reject({ result: 'failure' });
    }
  });

export default verifyCaptcha;
